module.exports = "/packs/media/images/brands/blackrock-62ed58771520952e542e3b4156e2d5f0.png";